import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LoaderService } from './LoaderService';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule, MatProgressSpinnerModule],
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent {
  private loaderService = inject(LoaderService);

  isLoading: Subject<boolean> = this.loaderService.isLoading;
  color = 'success';
  mode = 'indeterminate';
  value = 50;
}
